/**
 * Language switcher — swaps the locale segment in the current URL.
 * /en/dashboard/profile → /ru/dashboard/profile
 * Preserves query string and hash.
 */
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "./I18nContext";
import { supportedLangs } from "./loadTranslations";

const LABELS = { en: "EN", ru: "RU", he: "עב" };

export function LanguageSwitcher({ className = "" }) {
  const { lang } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const switchTo = (newLang) => {
    if (newLang === lang) return;
    // Replace the first path segment (locale) with the new locale
    const parts = location.pathname.split("/"); // ['', 'en', 'dashboard', ...]
    if (supportedLangs.includes(parts[1])) {
      parts[1] = newLang;
    } else {
      parts.splice(1, 0, newLang);
    }
    navigate(parts.join("/") + location.search + location.hash, { replace: true });
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {supportedLangs.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => switchTo(l)}
          className={`px-2 py-1 text-sm rounded transition-colors ${
            lang === l ? "bg-primary text-white" : "hover:bg-gray-200"
          }`}
        >
          {LABELS[l] ?? l}
        </button>
      ))}
    </div>
  );
}
